import React from 'react';
import RegularButton from 'Douleutaras/components/RegularButton/RegularButton';

import './CtaSectionContent.scss';

interface CtaSectionContentProps {
  icon?: string;
  header: string;
  description: string;
  primaryBtn?: React.ReactNode;
  secondaryBtn?: React.ReactNode;
  primaryTitle?: string;
  secondaryTitle?: string;
  primaryAction?(): void;
  secondaryAction?(): void;
}

export const CtaSectionContent: React.FC<CtaSectionContentProps> = ({
  icon,
  header,
  description,
  primaryBtn,
  secondaryBtn,
  primaryTitle,
  secondaryTitle,
  primaryAction,
  secondaryAction
}) => {
  return (
    <>
      <div styleName="fixed-ccf-section__content">
        { Boolean(icon) &&
          <div styleName="fixed-ccf-section__icon">
            <img src={icon} />
          </div>
        }
        <div styleName="fixed-ccf-section__header">
          {header}
        </div>
        <div styleName="fixed-ccf-section__caption">
          {description}
        </div>
      </div>
      {Boolean(primaryBtn)
        ? primaryBtn
        : <RegularButton modifier="primary"
                         size="large"
                         fullWidth
                         onClick={primaryAction}
                         title={primaryTitle}
          />
      }
      { Boolean(secondaryBtn)
        ? secondaryBtn
        : (Boolean(secondaryTitle) && Boolean(secondaryAction))
          ? <RegularButton modifier="primary-outline"
                           size="large"
                           onClick={secondaryAction}
                           title={secondaryTitle}
            />
          // tslint:disable-next-line:no-null-keyword
          : null
      }
    </>
  );
};
